import { useMutation, useQueryClient } from "@tanstack/react-query";
import OnlineOrderValuesModel from "../../../models/formModels/onlineOrderValues.model";
import { useOktaAuth } from "@okta/okta-react";
import { useHistory } from "react-router-dom";
import toastMessages from "../../helpers/toastMessage";
import OnlineOrderActions from "../../../OnlineOrderActions";
import { useContext } from "react";
import { ApplicationState } from "../../../context/ApplicationStateContext";

function useUpdateOrder(id: string) {
 const { authState } = useOktaAuth();
 const queryClient = useQueryClient();
 const history = useHistory();
const {
    state: { selectedPhysicianData },
  } = useContext(ApplicationState);
 return useMutation({
  mutationKey: ["updateOrder"],
  mutationFn: (data: OnlineOrderValuesModel) => {
  const { patientName, ...restData } = data;
  const { testTypeId, ...patientInfoWithoutTestTypeId } = restData.patientInfo || {};
    const cleanedData = {
    ...restData,
    patientInfo: patientInfoWithoutTestTypeId,
  };
   const orderActions = new OnlineOrderActions(
    Number(data.organizationId),
    Number(data.physicianId),
    selectedPhysicianData,
    [],
    ""
   );
   return orderActions.updateOrder({
     data: cleanedData,
    token: authState?.accessToken?.accessToken ?? "",
    id,
   });
  },
  onSuccess: (res) => {
   queryClient.invalidateQueries({ queryKey: ["testsList"] });
   if (res?.data?.data?.isSave === "true") {
    history.push("/access/test-orders");
    toastMessages.success("Order updated successfully");
   } else {
    history.push(`/access/online-order/order-created?id=${id}`, {
     ...res.data,
    });
   }
   if (id) queryClient.refetchQueries({ queryKey: ["orderDetail", { id }] });
   else queryClient.invalidateQueries({ queryKey: ["orderDetail"] });
  },
  onError: (error: any) => {
   const errorMessage =
    error?.response?.data?.message ?? error.message ?? "Failed to update order";
   toastMessages.error(errorMessage);
  },
 });
}

export default useUpdateOrder;
